export default "__VITE_ASSET__35064292__"